<template>
  <div
    style="margin-top: 15%"
    class="animated fadeIn d-flex flex-column align-items-center justify-content-center"
    v-if="isLoading"
  >
    <div v-if="isLoading && isLoading !== true" style="margin-bottom: 16px">
      <h2>{{ isLoading }}</h2>
    </div>
    <div
      style="width: 10rem; height: 10rem"
      class="spinner-border text-primary"
      role="status"
    >
      <span class="sr-only">Loading...</span>
    </div>
  </div>
  <section v-else class="w-100 animated fadeIn" id="tables">
    <mdb-row class="mt-4">
      <mdb-col>
        <div class="d-flex justify-content-between flex-wrap">
          <form @submit.prevent class="d-flex align-items-center mr-5">
            <mdb-icon icon="search" class="mr-3" />

            <mdb-input
              style="width: 210px"
              class="m-0"
              type="text"
              v-model="inputSearch"
              placeholder="Digite o texto para filtrar"
            />
          </form>
          <mdb-btn
            class="btn btn-rounded m-0 mb-2 float-right"
            color="blue-grey"
            @click.native="
              () => {
                showModalAdd = true;
              }
            "
          >
            Criar Nova Coleção
          </mdb-btn>
          <div class="w-100 d-flex flex-column align-items-center">
            <mdb-tbl responsive hover bordered class="w-100 text-center">
              <colgroup>
                <col :span="columns.length" />
                <col style="width: 175px" />
              </colgroup>
              <thead class="bg-color-table">
                <tr class="text-white">
                  <th v-for="column in columns" :key="column">
                    {{ column }}
                    <mdb-icon
                      v-if="['Nome da Coleção'].includes(column)"
                      @click.native="handleSort(column)"
                      style="cursor: pointer; margin-left: 4px"
                      icon="sort"
                    />
                  </th>
                  <th>Ação</th>
                </tr>
              </thead>
              <tbody>
                <tr class="bordered" v-for="(item, index) in data" :key="index">
                  <td>
                    <span class="first-text font-weight-bold">
                      {{ item.name }}
                    </span>
                  </td>
                  <td>
                    <span class="first-text font-weight-bold">
                      {{
                        item.templatesSummaries
                          .filter((summary) =>
                            item.template_ids.includes(summary.template_id)
                          )
                          .reduce((acc, summary) => {
                            if (acc.length == 0) return summary.template_name;
                            return acc + ", " + summary.template_name;
                          }, [])
                      }}
                    </span>
                  </td>
                  <td>
                    <span
                      class="first-text font-weight-bold"
                      v-if="credentials"
                    >
                      {{
                        item.whatsAppIdentifiers
                          .map((identificador) => {
                            return credentials.find(
                              (credential) =>
                                credential.identificador == identificador
                            ).numero_whatsapp;
                          })
                          .reduce((acc, number) => {
                            if (acc.length == 0) return number;
                            return acc + ", " + number;
                          }, [])
                      }}
                    </span>
                  </td>
                  <td class="pt-1">
                    <span class="first-text font-weight-bold">
                      <div
                        class="d-flex justify-content-evenly align-items-center"
                        style="font-size: 10px"
                      >
                        <div>
                          <mdb-btn
                            title="Visualizar"
                            type="button"
                            class="btn btn-blue btn-rounded m-0 ml-3 text-btn nowrap"
                            @click.native="
                              () => {
                                showModalTemplatesView = true;
                                indexTemplateChoosen = index;
                              }
                            "
                          >
                            <mdb-icon icon="eye" />Ver Templates
                          </mdb-btn>
                        </div>
                        <div>
                          <mdb-btn
                            title="Deletar"
                            type="button"
                            class="btn btn-blue btn-rounded m-0 ml-3 text-btn nowrap"
                            @click.native="
                              () => {
                                deleteCollection(item.name);
                              }
                            "
                          >
                            <mdb-icon icon="trash"></mdb-icon>Deletar Coleção
                          </mdb-btn>
                        </div>
                      </div>
                    </span>
                  </td>
                </tr>
              </tbody>
            </mdb-tbl>
            <mdb-pagination lg>
              <mdb-page-nav
                prev
                :disabled="currentPageSet === 1"
                @click.native="previousPageSet"
              ></mdb-page-nav>

              <mdb-page-item
                @click.native="
                  alterPage(n + (currentPageSet - 1) * pagesToShow)
                "
                v-for="n in totalPageSet"
                :key="n"
                :active="page === n + (currentPageSet - 1) * pagesToShow"
                :disabled="page === n + (currentPageSet - 1) * pagesToShow"
                >{{ n + (currentPageSet - 1) * pagesToShow }}</mdb-page-item
              >
              <mdb-page-nav
                next
                :disabled="currentPageSet === pageSet"
                @click.native="nextPageSet"
              ></mdb-page-nav>
            </mdb-pagination>
          </div>
        </div>
      </mdb-col>
    </mdb-row>
    <portal to="notification-outlet">
      <modal-create-collection
        :showModalAdd="showModalAdd"
        :credentials="credentials"
        :numbers="numbers"
        :loading="loading"
        @input="input"
        @renderTable="renderTable"
      />

      <modal-view-templates
        :showModalTemplatesView="showModalTemplatesView"
        :data="data[indexTemplateChoosen]"
        @input="input"
      />
    </portal>
  </section>
</template>

<script>
import {
  mdbRow,
  mdbInput,
  mdbIcon,
  mdbCol,
  mdbBtn,
  mdbTbl,
  mdbPagination,
  mdbPageItem,
  mdbPageNav,
} from "mdbvue";
import {
  getTemplateCollections,
  deleteCollection,
  getTemplateCollectionByName,
} from "../../services/TemplateCollection";
import ModalCreateCollection from "../../components/Modal/ModalCreateCollection.vue";

import { listCredentials } from "../../services/Auth";
import ModalViewTemplates from "../../components/Modal/ModalViewTemplates.vue";
export default {
  components: {
    mdbRow,
    mdbBtn,
    mdbInput,
    mdbIcon,
    mdbCol,
    mdbTbl,
    ModalCreateCollection,
    ModalViewTemplates,
    mdbPagination,
    mdbPageItem,
    mdbPageNav,
  },
  computed: {
    currentPageSet() {
      return Math.ceil(this.page / this.pagesToShow);
    },
    pageSet() {
      return Math.ceil(this.totalPages / this.pagesToShow);
    },
    totalPageSet() {
      if (this.currentPageSet === this.pageSet) {
        return this.totalPages % this.pagesToShow;
      }
      return this.pagesToShow;
    },
  },
  watch: {
    inputSearch() {
      console.warn(this.$route);
      const filtered = this.dataBkp.filter(this.filterCollection);
      this.page = 1;
      this.totalPages = parseInt(Math.ceil(filtered.length / this.limit));
      this.data = this.paginate(filtered, this.limit, this.page);
    },
  },
  data() {
    return {
      isLoading: false,
      loading: false,
      columns: [
        "Nome da Coleção",
        "Templates Escolhidos",
        "Números escolhidos",
      ],
      data: [],
      dataBkp: [],
      page: 1,
      limit: 10,
      totalPages: 1,
      pagesToShow: 10,
      numbers: [],
      credentials: [],
      showModalAdd: false,
      showModalTemplatesView: false,
      indexTemplateChoosen: 0,
      filterCollection: "",
      inputSearch: "",
    };
  },
  mounted() {
    this.renderTable();
  },
  created() {
    listCredentials()
      .then((data) => {
        this.credentials = data;
        if (data.length) {
          // remove and clean array to be unique
          this.numbers = (data || []).reduce((acc, el) => {
            if (!acc.includes(el.numero_whatsapp)) {
              acc.push({ label: el.numero_whatsapp, value: el.identificador });
            }
            return acc;
          }, []);
        }
      })
      .catch(() => {
        this.$toast.open({
          position: "top",
          message:
            "Ops, aconteceu um erro ao buscar as credenciais para o usuário atual! Tente novamente com outro usuário!",
          type: "error",
        });
      });
  },
  methods: {
    // Chama as variáveis do data
    input(key, value, cb) {
      this[key] = value;
      if (cb) this[cb]();
    },
    alterPage(selectedPage) {
      this.page = selectedPage;
      this.renderTable();
    },
    previousPageSet() {
      const iterableCurrentPageSet = this.currentPageSet - 1;
      this.alterPage(this.pagesToShow * (iterableCurrentPageSet - 1) + 1);
    },
    nextPageSet() {
      const iterableCurrentPageSet = this.currentPageSet - 1;
      this.alterPage(this.pagesToShow * (iterableCurrentPageSet + 1) + 1);
    },
    paginate(array, page_size, page_number) {
      return array.slice(
        (page_number - 1) * page_size,
        page_number * page_size
      );
    },
    renderTable() {
      this.isLoading = true;
      if (this.$route.params.name) {
        this.searchTemplateCollectionByName();
      } else {
        const offset = this.limit * (this.page - 1);
        getTemplateCollections(this.limit, offset).then((res) => {
          this.isLoading = false;
          const resultData = res.results;
          this.dataBkp = [...resultData];
          this.totalPages = parseInt(Math.ceil(res.total / this.limit));
          this.data = [...resultData];
        });
      }
    },
    deleteCollection(name) {
      this.isLoading = true;
      deleteCollection(name)
        .then(
          this.$toast.open({
            position: "top",
            message: "Coleção deletada com sucesso!",
            type: "success",
          })
        )
        .catch(() => {
          this.$toast.open({
            position: "top",
            message:
              "Ops, aconteceu um erro ao deletar sua coleção! Tente mais tarde!",
            type: "error",
          });
        })
        .finally(() => {
          this.renderTable();
          this.isLoading = false;
        });
    },
    searchTemplateCollectionByName() {
      getTemplateCollectionByName(this.$route.params.name)
        .then((res) => {
          // this.data = [...resultData];
          // console.warn(this.$route);
          // console.warn(this.$route.matched[0].props.default.page);
          // console.log([res]);
          this.dataBkp = [res];
          this.data = [res];
        })
        .catch(() => {
          this.$toast.open({
            position: "top",
            message:
              "Ops, aconteceu um erro ao buscar sua coleção! Tente mais tarde!",
            type: "error",
          });
          this.$router.push(`/campaign`);
        })
        .finally(() => {
          this.renderTable();
          this.isLoading = false;
        });
    },
  },
};
</script>

<style>
.text-btn {
  display: flex;
  align-content: center;
  flex-direction: row;
  justify-content: center;
  font-weight: bold;
  text-transform: capitalize;
  font-size: 12pt;
}
.nowrap {
  white-space: nowrap;
}
.text-btn i {
  margin-right: 1em;
  display: flex;
  align-self: center;
}
.page-item.active.disabled.ripple-parent a {
  color: white !important;
}
</style>